module.exports = __webpack_public_path__ + "img/FR-Wix-integration-vidjet-step1.83e8c3b8.png";